export default __webpack_public_path__ + "static/media/slider_5-md@1x.c53de744.webp";